// extracted by mini-css-extract-plugin
module.exports = {"card":"EventInfoCard_card__Y341M","card-content":"EventInfoCard_card-content__2NR-u","header":"EventInfoCard_header__2C_B4","event":"EventInfoCard_event__1Zz-l"};